module.exports = __webpack_public_path__ + "static/14gde-ac773d696264ac044a73f98c48dad3ae.gif";